$(function(){

    var h = $('.js-contact-btn').offset().top;
    $('.js-contact-btn').addClass('fix');
    $(window).scroll(function(){
      var scroll = $(this).scrollTop();
      var wh = $(this).height();
      console.log(scroll);
      if (scroll >=  ((h - wh) + 70)){
        $('.js-contact-btn').removeClass('fix');
      }else {
        $('.js-contact-btn').addClass('fix');
      }
    });
  
    $('.js-contact-btn').on('click', function(){
        $('.js-contact-bg').fadeIn(300);
        $('.contact').addClass('open');
    });
    
    $('.js-contact-bg, .js-close-btn').on('click', function(){
      $('.js-contact-bg').fadeOut(300);
      $('.contact').removeClass('open');
   });
});